import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ReadonlyTransaction } from '@atlaskit/editor-prosemirror/state';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const blockCollapsePluginKey: PluginKey = new PluginKey('blockCollapsePlugin');

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type BlockCollapsePluginState = {};

export const createPlugin = (): SafePlugin<BlockCollapsePluginState> => {
	return new SafePlugin<BlockCollapsePluginState>({
		key: blockCollapsePluginKey,
		state: {
			init() {
				return {};
			},
			apply: (tr: ReadonlyTransaction, currentPluginState: BlockCollapsePluginState) => {
				const meta = tr.getMeta(blockCollapsePluginKey);
				if (meta) {
					return meta;
				}
				return currentPluginState;
			},
		},
	});
};
